import { useSuspenseQuery } from "@tanstack/react-query";

/** Provider names by AAGUID. */
export type PasskeyProviders = Partial<Record<string, string>>;

/**
 * Passkey providers catalog — the names of the apps and devices that keep
 * passkeys. Unlike the other catalogs, it comes with the build rather than from
 * the API (`pnpm passkey-providers:update` refreshes it), and only loads once a
 * user with a passkey needs it.
 */
function passkeyProvidersQuery() {
  return {
    queryKey: ["passkey-providers"],
    queryFn: async (): Promise<PasskeyProviders> =>
      (await import("./passkey-providers.json")).default,
    staleTime: Infinity,
  };
}

export function usePasskeyProviders(): PasskeyProviders {
  // Suspends the nearest boundary until loaded, so callers always get data.
  return useSuspenseQuery(passkeyProvidersQuery()).data;
}
